import React, {Component} from 'react';
import {Input, Form} from "antd";
import BaseComponent from "../../../../base/BaseComponent";

class TextShow extends BaseComponent {
    static defaultProps = {
        show: true,
    };

    constructor(props) {
        super(props);
        this.state = {}
    }

    componentDidMount() {
        // console.log(window.currentUser)
    }


    render() {
        //过滤当前登录的用户和当前数据的中的名字和账号是否相同，相同则显示我的角色
        let value = '';
        if (this.props.type == 'receiver') {
            if (this.props.itemValue) {
                let myRole = this.props.itemValue.filter(item => (item.reporter.name == window.currentUser.name && item.reporter.account == window.currentUser.account));
                value = myRole && myRole.length ? myRole[0].taskRole.join('，') : ''
            }
        } else {
            value = this.props.itemValue
        }
        return (
            <Form.Item label={this.props.label}
                       hidden={!this.props.show}
                       labelCol={{span: 3}}
                       wrapperCol={{span: 30}}
                       style={{display: "flex",width: '50%'}}>
                <div style={{lineHeight:1.5,paddingTop:10}}>{value}</div>
            </Form.Item>

        );
    }

}

export default TextShow